export default __webpack_public_path__ + "/dist/images/mail-icon.dd1d0e0a5c447d3280a999111d7cda6f.svg";